"use client";

import { Pause, Play } from "@/components/icons";
import { IconButton } from "@/components/ui/icon-button";

export function LandingDemoPlayToggle({ isPlaying, onToggle }: { isPlaying: boolean; onToggle: () => void }) {
  return (
    <IconButton type="button" variant="outline" aria-label={isPlaying ? "Pause demo" : "Play demo"} onClick={onToggle}>
      {isPlaying ? <Pause /> : <Play />}
    </IconButton>
  );
}
